<template>
  <div class="loading-component">
    <IconLoading />
  </div>
</template>

<script>
import IconLoading from 'fe-vui/IconLoading'

export default {
  components: {
    IconLoading
  }
}
</script>

<style scoped>
.loading-component {
  display: flex;
  height: 200px;
  align-items: center;
  justify-content: center;
}
</style>
